import angular from 'angular';

import CompileComponentDirective, { selector } from './compile-component.directive';

export default angular
    .module('application.directive.compile-component', [])
    .directive(selector, CompileComponentDirective);



// WEBPACK FOOTER //
// ./src/application/directive/compile-component/index.js